export default "__VITE_ASSET__Dl7oZ8sP__"